import { computed } from "vue";

export const useMenu = () => {
  const { t } = useI18n();

  return computed(() => [
    { label: t("nav.home"), link: "/" },
    { label: t("nav.about"), link: "/about" },
    { label: t("nav.prices"), link: "/prices" },
    { label: t("nav.amenities"), link: "/amenities" },
    { label: t("nav.services"), link: "/guest-services" },
    { label: t("nav.location"), link: "/location" },
  ]);
};
